import { useGetAccountOrderAuthorizationsQuery } from "@apis/accounts/useAccounts"
import type { IOrder } from "@commonTypes/order"
import { SquareArrowOutUpRight } from "lucide-react"
import { Link } from "react-router"

const EnrollmentDocs = ({ order }: { order: IOrder }) => {
  const getAccountOrderAuthorizations = useGetAccountOrderAuthorizationsQuery(
    String(order.account_id),
  )

  if (getAccountOrderAuthorizations.isError) {
    return (
      <div className="tw:text-red-500">
        Error getting account order authorizations:{" "}
        {getAccountOrderAuthorizations.error.message}
      </div>
    )
  }

  return (
    <div>
      <h3>Enrollment Docs</h3>
      {order.contract_url && (
        <Link to={order.contract_url}>
          Contract
          <SquareArrowOutUpRight size={24} className="tw:inline-block tw:p-1" />
        </Link>
      )}

      {getAccountOrderAuthorizations.data?.length ? (
        getAccountOrderAuthorizations.data.map((auth, index) => {
          return (
            <div key={`${auth.order_authorization_letter_id}-${index}`}>
              <Link to={auth.url}>
                {auth.name}
                <SquareArrowOutUpRight
                  size={24}
                  className="tw:inline-block tw:p-1"
                />
              </Link>
            </div>
          )
        })
      ) : (
        <div>No enrollment docs available</div>
      )}
    </div>
  )
}

export default EnrollmentDocs
